// extracted by mini-css-extract-plugin
export var badge = "WPEventTeaser-module--badge--Cv-xd";
export var content = "WPEventTeaser-module--content--LQHkp";
export var date = "WPEventTeaser-module--date--V7P8P";
export var excerpt = "WPEventTeaser-module--excerpt--F7hTK";
export var icon = "WPEventTeaser-module--icon--sd9WG";
export var image = "WPEventTeaser-module--image --8XFiu";
export var teaser = "WPEventTeaser-module--teaser--yNPai";